// Konfiguracja tabeli ostatnio zalogowanych użytkowników dla dashboardu handlowca

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Funkcja tworząca konfigurację parametrów (opcji nad tabelą)
 */
export const getTraderDashboardRecentlyLoggedTableParameters = (
): IWiseTableParameter[] => {
  return [];
};

/**
 * Funkcja tworząca konfigurację kolumn
 * @param t - funkcja tłumaczeń
 */
export const getTraderDashboardRecentlyLoggedTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'avatar',
      label: t('Klient'),
      field_symbol: 'client_name',
      align: 'left',
      tooltip: null,
      size: 200
    },
    {
      type: 'text',
      label: t('Login'),
      field_symbol: 'login',
      align: 'center',
      tooltip: null,
      size: 120
    },
    {
      type: 'date',
      label: t('Data'),
      field_symbol: 'sys_last_login_date',
      align: 'center',
      tooltip: null,
      size: 150
    },
    {
      type: 'text',
      label: 'ID',
      field_symbol: 'id',
      align: 'center',
      tooltip: null,
      size: 100
    }
  ];
};

/**
 * Funkcja tworząca konfigurację akcji
 */
export const getTraderDashboardRecentlyLoggedTableActions = (): IWiseTableAction[] => {
  return [];
};

/**
 * Parametry do pobierania danych
 * Mockowany endpoint - będzie zwracał dane z JSON
 */
export const traderDashboardRecentlyLoggedTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/dashboard/users_active',
  params_list: null
};
